import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  ERPEntityMappingDTO,
  ERPEntityMappingList,
  ERPEntityMappingCreateRequestDTO,
  ERPEntityMappingReadByIdRequestDTO,
  ERPEntityMappingReadByMasterRequestDTO,
  ERPEntityMappingUpdateRequestDTO,
  ERPEntityMappingDeleteRequestDTO,
  ERPEntityMappingCreateBulkRequestDTO,
  ERPCompanyOnboardingRequestDTO,
  ERPUserMasterOnboardingRequestDTO,
  supportTicketCreateRequestDTO,
  ERPValueListItemCreateRequestDTO,
  ERPLeadMasterCreateRequestDTO,
  ERPUserDeleteRequestDTO,
  ERPTicketActivityCreateRequestDTO,
} from "./ERPEntityMapping.interface";
import {
  ERPEntityMapping_Create,
  ERPEntityMapping_CreateBulk,
  ERPEntityMapping_CreateLeadMaster,
  ERPEntityMapping_CreateSupportTickets,
  ERPEntityMapping_CreateTicketActivity,
  ERPEntityMapping_CreateValueListItem,
  ERPEntityMapping_Delete,
  ERPEntityMapping_ExternalReadByMasterId,
  ERPEntityMapping_Onboarding,
  ERPEntityMapping_ReadAll,
  ERPEntityMapping_ReadById,
  ERPEntityMapping_ReadByMasterId,
  ERPEntityMapping_Update,
  ERPEntityMapping_UserMasterDelete,
  ERPEntityMapping_UserMasterOnboarding,
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class ERPEntityMappingService {
  http = inject(HttpClient);

  ERPEntityMapping_Create(
    data: ERPEntityMappingCreateRequestDTO
  ): Observable<ERPEntityMappingDTO> {
    return this.http.post<ERPEntityMappingDTO>(ERPEntityMapping_Create, data);
  }

  ERPEntityMapping_ReadAll(): Observable<ERPEntityMappingList> {
    return this.http.get<ERPEntityMappingList>(ERPEntityMapping_ReadAll);
  }

  ERPEntityMapping_ReadById(
    data: ERPEntityMappingReadByIdRequestDTO
  ): Observable<ERPEntityMappingDTO> {
    return this.http.post<ERPEntityMappingDTO>(ERPEntityMapping_ReadById, data);
  }

  ERPEntityMapping_ReadByMasterId(
    data: ERPEntityMappingReadByMasterRequestDTO
  ): Observable<ERPEntityMappingList> {
    return this.http.post<ERPEntityMappingList>(
      ERPEntityMapping_ReadByMasterId,
      data
    );
  }

  ERPEntityMapping_ExternalReadByMasterId(
    data: ERPEntityMappingReadByMasterRequestDTO
  ): Observable<ERPEntityMappingList> {
    return this.http.post<ERPEntityMappingList>(
      ERPEntityMapping_ExternalReadByMasterId,
      data
    );
  }

  ERPEntityMapping_Update(
    data: ERPEntityMappingUpdateRequestDTO
  ): Observable<ERPEntityMappingDTO> {
    return this.http.post<ERPEntityMappingDTO>(ERPEntityMapping_Update, data);
  }

  ERPEntityMapping_Delete(
    data: ERPEntityMappingDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(ERPEntityMapping_Delete, data);
  }

  ERPEntityMapping_CreateBulk(
    data: ERPEntityMappingCreateBulkRequestDTO
  ): Observable<ERPEntityMappingList> {
    return this.http.post<ERPEntityMappingList>(
      ERPEntityMapping_CreateBulk,
      data
    );
  }

  ERPCompanyOnboarding_Create(
    data: ERPCompanyOnboardingRequestDTO
  ): Observable<void> {
    return this.http.post<void>(ERPEntityMapping_Onboarding, data);
  }

  ERPUserMasterOnboarding_Create(
    data: ERPUserMasterOnboardingRequestDTO
  ): Observable<void> {
    return this.http.post<void>(ERPEntityMapping_UserMasterOnboarding, data);
  }

  ERPUserMasterOnboarding_Delete(data: ERPUserDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ERPEntityMapping_UserMasterDelete , data);
  };

  ERPSupportTicket_Create(
    data: supportTicketCreateRequestDTO
  ): Observable<any> {
    return this.http.post<any>(ERPEntityMapping_CreateSupportTickets, data);
  }

  ERPValueListItem_Create(
    data: ERPValueListItemCreateRequestDTO
  ): Observable<any> {
    return this.http.post<any>(ERPEntityMapping_CreateValueListItem, data);
  }

  ERPLeadMaster_Create(data: ERPLeadMasterCreateRequestDTO): Observable<any> {
    return this.http.post<any>(ERPEntityMapping_CreateLeadMaster, data);
  }

  ERPTicketActivity_Create(data: ERPTicketActivityCreateRequestDTO): Observable<any> {
    return this.http.post<any>(ERPEntityMapping_CreateTicketActivity, data);
  }
  
}
